module.exports = __webpack_public_path__ + "img/delta_background--small.cc8f6bfc.png";